import { config } from '../config';

const errorMessage = '[apiAcceptance] error to method';

export const apiAcceptance = {
  getAcceptancesDocuments: async (axiosPrivate) => {
    try {
      const response = await axiosPrivate.get(`${config.API.ACCEPTANCE.DOCUMENTS}`);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'getAcceptancesDocuments', error);
      throw error;
    }
  },
  getAcceptanceDocumentByType: async (axiosPrivate, type) => {
    try {
      const response = await axiosPrivate.get(`${config.API.ACCEPTANCE.DOCUMENT(type)}`);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'getAcceptanceDocumentByType', error);
      throw error;
    }
  },
  acceptAcceptance: async (axiosPrivate, documentId) => {
    try {
      const response = await axiosPrivate.post(`${config.API.ACCEPTANCE.ACCEPT(documentId)}`);
      return response.data.data;
    } catch (error) {
      console.error(errorMessage + 'acceptAcceptance', error);
      throw error;
    }
  },
};
